<script>
  import { Route, navigateTo } from "svelte-router-spa";

  export let currentRoute;
  export let params;

  import { isLoggedIn } from "../../../utils/store.js";

  let username = null;
  let password = null;
  let error = null;

  async function login() {
    const response = await fetch(process.env.BACKEND_URL + 'login', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: username,
        password: password,
      }),
      credentials: "include",
    });

    if (response.ok) {
      isLoggedIn.set(true);
      navigateTo("/");
    } else {
      error = "Kullanıcı adı ya da şifre hatalı. Tekrar deneyiniz.";
    }
  }
</script>

<svelte:head>
  <title>Giriş Yap</title>
</svelte:head>

<div class="vh-100 vw-100 d-flex align-items-center justify-content-center">
  <div class="border border-light shadow" style="padding: 100px;">
    <form on:submit|preventDefault={login}>
      <div class="mb-3">
        <label for="username" class="form-label">Kullanıcı Adı</label>
        <input
          type="text"
          class="form-control"
          id="username"
          bind:value={username}
        />
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Şifre</label>
        <input
          type="password"
          class="form-control"
          id="password"
          bind:value={password}
        />
      </div>
      <div class="text-center">
        {#if error}
          <div class="alert alert-danger" role="alert">
            {error}
          </div>
        {/if}
        <button type="submit" class="btn btn-outline-primary">Giriş Yap</button>
      </div>
    </form>
  </div>
  <Route {currentRoute} {params} />
</div>
